import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-brand-50 px-4 py-16 sm:py-24" aria-labelledby="bonuses-title" data-id="element-72" data-mp="aujzm9neq52y">
      <div className="mx-auto max-w-4xl" data-id="element-73" data-mp="fsv8oi5vobk4">
        <div id="bonuses-title" data-id="element-74" data-mp="frtlxgfi20mk">
          <SectionHeading eyebrow="Exclusive bonuses" title={<>
                Get these 5 bonuses <em className="text-brand-700" data-id="element-76" data-mp="5xjt5xmnb0bb">free today</em>
              </>} data-id="element-75" data-mp="1u5bz3mz0dwa" />
        </div>
        <div className="mt-5 flex flex-col items-center gap-2" data-id="element-77" data-mp="3o3fye0h2f3kw">
          <p className="rounded-full bg-gold-light px-4 py-1.5 text-sm font-bold text-gold-dark" data-id="element-78" data-mp="3t1r9sfn0dm58">Bonus value: $197+</p>
          <p className="text-sm font-semibold text-brand-800" data-id="element-79" data-mp="1martznsoqa3j">Included free with your $27 purchase</p>
        </div>

        <div className="mt-10 space-y-8" data-id="element-80" data-mp="1r8jtp3zkn0ia">
          {bonuses.map(b => <article key={b.number} className="-mx-4 overflow-hidden bg-white shadow-sm ring-1 ring-brand-100 sm:mx-0 sm:rounded-3xl" data-id="element-81" data-mp="3id52z1tcov8o">
              <div className="flex items-center justify-between gap-3 bg-brand-800 px-5 py-3 text-white" data-id="element-82" data-mp="3r700pos57jea">
                <span className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-wider" data-id="element-83" data-mp="3n67ocmnz4yds">
                  <GiftIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-84" data-mp="2zgddubr4nlwp" />
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-semibold" data-id="element-85" data-mp="2uiu1jhdzpj7e">
                  Value: <span className="text-brand-200 line-through" data-id="element-86" data-mp="38htomklutq1g">{b.value}</span>
                </span>
              </div>

              <img src={b.image} alt={`${b.title} mockup`} className="block w-full bg-white" loading="lazy" data-id="element-87" data-mp="33ja32lb6ag9m" />

              <div className="px-5 pb-7 pt-5 sm:px-8" data-id="element-88" data-mp="nrukkm7xk144">
                <h3 className="font-serif text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-89" data-mp="iq558udod1a8">{b.title}</h3>
                <div className="mt-3 space-y-2 text-[16px] leading-relaxed text-muted" data-id="element-90" data-mp="3ciel71cjvqy1">
                  {b.description.map(p => <p key={p} data-id="element-91" data-mp="3ljl5zmm8fnx3">{p}</p>)}
                </div>
                <p className="mt-5 text-xs font-bold uppercase tracking-wider text-ink" data-id="element-92" data-mp="3lhi5u9rd8een">{b.includesLabel}</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-93" data-mp="3qgbmgb1y8lj1">
                  {b.includes.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-ink/85" data-id="element-94" data-mp="2xtqsr3y03xcb">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-95" data-mp="32td6dehqrfln" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-6 inline-flex rounded-full bg-cta/10 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-cta-dark" data-id="element-96" data-mp="2a4fp9ep9nouh">
                  Included free today
                </p>
              </div>
            </article>)}
        </div>

        <SectionCta label="I want all 5 bonuses free" data-id="element-97" data-mp="27j88oy3zn3u3" />
      </div>
    </section>;
}